export default function SocialYenOutline() {
  return (
    <div
      className="ion-icon-social-yen-outline"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
<path d="M448,32h-80L256,253.128L144,32H64l112.368,208H128v48h73.564L216,319v17h-88v48h88v96h80v-96h88v-48h-88v-17l14.891-31H384
	v-48h-48.289L448,32z M368,256v16h-67l-21,43v37h88v16h-88v96h-48v-96h-88v-16h88v-35.75L212,272h-68v-16h59.197l-12.752-23.605
	L90.829,48H134l122,240L378,48h43h0.18l-99.548,184.399L308.891,256H368z"/>
</svg>
`,
      }}
    />
  )
}
